import { render } from "./Trophy.vue?vue&type=template&id=c59bb684"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Trophy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c59bb684"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c59bb684', __exports__)) {
    api.reload('c59bb684', __exports__)
  }
  
  module.hot.accept("./Trophy.vue?vue&type=template&id=c59bb684", () => {
    api.rerender('c59bb684', render)
  })

}


export default __exports__